type TIsValidValue = {
    maxValue?: number;
    minValue?: number;
    value: number;
};

export const hasValue = (value?: never) => ![null, undefined, ''].includes(value);

export function isValidValue({ maxValue, minValue, value }: TIsValidValue) {
    if (minValue !== undefined && maxValue !== undefined) {
        return minValue < value && value < maxValue;
    }
    if (minValue !== undefined) {
        return value >= minValue;
    }
    if (maxValue !== undefined) {
        return value <= maxValue;
    }

    return Boolean(value);
}
